
import React from "react"
import { diaMesAno, colores } from "./general"
import { useHistory } from "react-router-dom"

export default function Tarea({ t }) {
    let history = useHistory()
    let color = colores["prioridad"];
    let colorT = { Actividad: "#CECEF6", Accion: "#F3E2A9", Incidente: "#D8F781", Riesgo: "#A9F5A9" }

    return (
        <>
            <div style={{ ...Starea, background: colorT[t.tipo] }} onClick={() => { history.push("Actualizacion", { tarea: t }) }}>
                <div style={SprimerLinea}>{`${t.tipo}: ${t.proyecto}/${t.id}`}</div>
                <div style={SsegundaLinea}>
                    {`Fin Estimado: ${diaMesAno(t.finEstimado)}`}
                    <div style={{ ...Scirculo, background: color[t.prioridad] }}></div>
                    <div>&nbsp;&nbsp;</div>
                </div>
                <div style={Sdescripcion}>{t.descripcion}</div>
            </div>
        </>
    )

}

const Starea = {
    width: "99%",
    padding: "7px",
    borderRadius: "10px",
    cursor: "pointer"
}

const SprimerLinea = {
    fontSize: "2vh",
    marginBottom: "5px"
}

const SsegundaLinea = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: "2.2vh",
    fontWeight: 700,
    marginBottom: "5px",
}

const Sdescripcion = {
    fontSize: "1.6vh",
    marginBottom: "5px",
    maxHeight: "14vh",
    overflowY: "auto"
}

const Scirculo = {
    height: "25px",
    width: "25px",
    borderRadius: "50%",
}


